// CMYK color type

export type CMYKColor = {
  a: number // alpha
  c: number // cyan
  k: number // key/black
  m: number // magenta
  y: number // yellow
}
